module.exports = __webpack_public_path__ + "img/badge-member-brightbg.fdf8e0d9.svg";